module.exports = __webpack_public_path__ + "static/media/map-marker-rc.ee0a893e.png";